import "./footer.css";

export default function Footer() {
  return (
    <div className="footerAll">
      <div className="footer">
        <small id="repository">
          <a
            rel="noreferrer"
            href="https://github.com/Rietiefen/weatherapp_react"
            target="_blank"
          >
            Open-source code
          </a>
          <span> by Rie Tiefenbach</span>
        </small>
      </div>
      <script src="src/index.js"></script>
    </div>
  );
}
